import { configureStore } from '@reduxjs/toolkit';
import animationsReducer from '../features/animationsSlice';

export const store = configureStore({
  reducer: {
    animations: animationsReducer,
  },
  devTools: true,
});
